"use strict";

jQuery(document).ready(function ($) {
  var video = document.querySelector('#video');
  var close = document.querySelector('.video__btn__close');
  var mask = document.querySelector('.mask'); //$( ".video__image" ).on( "click", function() {

  $(".play-button").on("click", function () {
    $(this).hide();
    $('.video__image').hide();
    $(".mask, .video__btn__close").css('display', 'block');
    $(".video__movie").show();
    $(".video__cell").removeClass('video__movie--shrink').addClass('video__movie--grow');
    video.play();
  });
  video.addEventListener('ended', stopMedia);
  close.addEventListener('click', stopMedia);
  mask.addEventListener('click', stopMedia);

  function stopMedia() {
    video.pause();
    video.currentTime = 0;
    $(".mask, .video__btn__close").css('display', 'none');
    $(".video__cell").removeClass('video__movie--grow').addClass('video__movie--shrink');
    $(".video__movie").hide();
    $(".video__image").show();
    $(".play-button").show();
  }

  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      // escape key maps to keycode `27`
      stopMedia();
    }
  });
});
TweenMax.set(".play-circle-01", {
  rotation: 90,
  transformOrigin: "center"
});
TweenMax.set(".play-circle-02", {
  rotation: -90,
  transformOrigin: "center"
});
TweenMax.set(".play-perspective", {
  // xPercent: 6.5,
  // scale: .175,
  transformOrigin: "center",
  perspective: 1
});
TweenMax.set(".play-video", {
  visibility: "hidden",
  opacity: 0
});
TweenMax.set(".play-triangle", {
  // 	transformOrigin: "left center",
  // //	transformStyle: "preserve-3d",
  // 	rotationY: 10,
  // 	scaleX: 2
  display: "block"
});
var rotateTL = new TimelineMax({
  paused: true
}).to(".play-circle-01", .7, {
  opacity: .1,
  rotation: '+=360',
  strokeDasharray: "456 456",
  ease: Power1.easeInOut
}, 0).to(".play-circle-02", .7, {
  opacity: .1,
  rotation: '-=360',
  strokeDasharray: "411 411",
  ease: Power1.easeInOut
}, 0);
var rotateInfiniteTL = new TimelineMax({
  repeat: -1,
  yoyo: true
}).to(".play-circle-01", 1.5, {
  opacity: .1,
  rotation: '+=360',
  strokeDasharray: "456 456",
  ease: Power1.easeInOut
}, 0).to(".play-circle-02", 1.5, {
  opacity: .1,
  rotation: '-=360',
  strokeDasharray: "411 411",
  ease: Power1.easeIn
}, 0);
rotateInfiniteTL.play(); // const button = document.querySelector(".play-button")
// button.addEventListener("mouseover", () => rotateTL.play())
// button.addEventListener("mouseleave", () => rotateTL.reverse())
//
//button.addEventListener("oninit", () => rotateTL.play())